import { Injectable } from '@angular/core';
import { LocalStorage } from '@ngx-pwa/local-storage';
import { Howl } from 'howler';

@Injectable({
    providedIn: 'root',
})
export class SharedService {
    constructor(private LocalStorage: LocalStorage) {}

    accessOrdersList: boolean;

    accessComplainsList: boolean;

    editorFullScreen: boolean;

    sidebarOpen: boolean = true;

    sidebarItems = [
        {
            name: 'Dashboard',
            icon: 'fas fa-home',
            isOpen: false,
            isOpenMobile: false,
            items: [
                {
                    name: 'Home',
                    link: '',
                    isActive: false,
                },
            ],
        },

        {
            name: 'Content',
            icon: 'fas fa-edit',
            isOpen: false,
            isOpenMobile: false,
            items: [
                {
                    name: 'Branch',
                    link: 'branch-list',
                    isActive: false,
                },
                {
                    name: 'Location',
                    link: 'location-list',
                    isActive: false,
                },
                {
                    name: 'Section',
                    link: 'section-list',
                    isActive: false,
                },
                {
                    name: 'Product',
                    link: 'product-list',
                    isActive: false,
                },
                {
                    name: 'HomePage',
                    link: 'home-page',
                    isActive: false,
                },
                {
                    name: 'Media Library',
                    link: 'media-library',
                    isActive: false,
                },
            ],
        },
        {
            name: 'Orders',
            icon: 'fas fa-shopping-basket',
            isOpen: false,
            isOpenMobile: false,
            items: [
                {
                    name: 'Orders List',
                    link: 'orders/orders-list',
                    isActive: false,
                },
            ],
        },
        {
            name: 'Management',
            icon: 'fas fa-project-diagram',
            isOpen: false,
            isOpenMobile: false,
            items: [
                {
                    name: 'Complaints',
                    link: 'management/complain-list',
                    isActive: false,
                },
                {
                    name: 'Product Availability',
                    link: 'management/product-availability',
                    isActive: false,
                },
            ],
        },
        {
            name: 'Engagement',
            icon: 'fas fa-comments-alt',
            isOpen: false,
            isOpenMobile: false,
            items: [
                {
                    name: 'Contact',
                    link: 'engagement/contact',
                    isActive: false,
                },
                {
                    name: 'Product Review',
                    link: 'engagement/review',
                    isActive: false,
                },
                {
                    name: 'Survey',
                    link: 'engagement/survey',
                    isActive: false,
                },
            ],
        },
        {
            name: 'Offer',
            icon: 'fas fa-gift',
            isOpen: false,
            isOpenMobile: false,
            items: [
                {
                    name: 'Discount Period',
                    link: 'offer/discount-period',
                    isActive: false,
                },
                {
                    name: 'Discount Code',
                    link: 'offer/discount-list',
                    isActive: false,
                },
            ],
        },
        {
            name: 'Report',
            icon: 'fas fa-chart-area',
            isOpen: false,
            isOpenMobile: false,
            items: [
                {
                    name: 'End of day report',
                    link: 'report/end-of-day',
                    isActive: false,
                },
            ],
        },
        {
            name: 'Security',
            icon: 'fas fa-lock',
            isOpen: false,
            isOpenMobile: false,
            items: [
                {
                    name: 'Users',
                    link: 'user-list',
                    isActive: false,
                },
            ],
        },
    ];

    compliansTitles = [
        {
            name: 'شكوي كول سنتر',
            value: 'شكوي كول سنتر',
        },
        {
            name: 'شكوي الدليفري',
            value: 'شكوي الدليفري',
        },
        {
            name: 'شكوي تيك اوت',
            value: 'شكوي تيك اوت',
        },
        {
            name: 'شكوي فرع',
            value: 'شكوي فرع',
        },
    ];

    compliansSubTitles = [
        {
            name: 'لم يتم إرسال الأوردر',
            value: 'لم يتم إرسال الأوردر',
            title: 'شكوي كول سنتر',
        },
        {
            name: 'منتج مفقود',
            value: 'منتج مفقود',
            title: 'شكوي كول سنتر',
        },
        {
            name: 'سلوك موظف خدمة عملاء',
            value: 'سلوك موظف خدمة عملاء',
            title: 'شكوي كول سنتر',
        },
        {
            name: 'معلومات خاطئة',
            value: 'معلومات خاطئة',
            title: 'شكوي كول سنتر',
        },
        {
            name: 'منتج خاطئ',
            value: 'منتج خاطئ',
            title: 'شكوي كول سنتر',
        },
        {
            name: 'أوردر خاطئ',
            value: 'أوردر خاطئ',
            title: 'شكوي كول سنتر',
        },

        ///

        {
            name: 'تأخير أوردر',
            value: 'تأخير أوردر',
            title: 'شكوي الدليفري',
        },
        {
            name: 'سلوك الطيار',
            value: 'سلوك الطيار',
            title: 'شكوي الدليفري',
        },
        {
            name: 'منتج مفقود',
            value: 'منتج مفقود',
            title: 'شكوي الدليفري',
        },
        {
            name: 'جودة الأوردر',
            value: 'جودة الأوردر',
            title: 'شكوي الدليفري',
        },
        {
            name: 'جودة الأوردر للتأخير',
            value: 'جودة الأوردر للتأخير',
            title: 'شكوي الدليفري',
        },
        {
            name: 'جودة التعبئة والتغليف',
            value: 'جودة التعبئة والتغليف',
            title: 'شكوي الدليفري',
        },
        {
            name: 'حالة تسمم',
            value: 'حالة تسمم',
            title: 'شكوي الدليفري',
        },
        {
            name: 'منتج خاطئ',
            value: 'منتج خاطئ',
            title: 'شكوي الدليفري',
        },
        {
            name: 'أوردر خاطئ',
            value: 'أوردر خاطئ',
            title: 'شكوي الدليفري',
        },
        {
            name: 'مندوب طلبات',
            value: 'مندوب طلبات',
            title: 'شكوي الدليفري',
        },
        {
            name: 'مندوب المنيوز',
            value: 'مندوب المنيوز',
            title: 'شكوي الدليفري',
        },
        {
            name: 'مندوب فروريرة',
            value: 'مندوب فروريرة',
            title: 'شكوي الدليفري',
        },

        ///

        {
            name: 'تأجيل الطلب',
            value: 'تأجيل الطلب',
            title: 'شكوي تيك اوت',
        },
        {
            name: 'منتج مفقود',
            value: 'منتج مفقود',
            title: 'شكوي تيك اوت',
        },
        {
            name: 'جودة الأوردر',
            value: 'جودة الأوردر',
            title: 'شكوي تيك اوت',
        },
        {
            name: 'جودة التعبئة والتغليف',
            value: 'جودة التعبئة والتغليف',
            title: 'شكوي تيك اوت',
        },
        {
            name: 'سلوك موظف فرع',
            value: 'سلوك موظف فرع',
            title: 'شكوي تيك اوت',
        },
        {
            name: 'حالة تسمم',
            value: 'حالة تسمم',
            title: 'شكوي تيك اوت',
        },
        {
            name: 'منتج خاطئ',
            value: 'منتج خاطئ',
            title: 'شكوي تيك اوت',
        },
        {
            name: 'أوردر خاطئ',
            value: 'أوردر خاطئ',
            title: 'شكوي تيك اوت',
        },

        ///

        {
            name: 'منتج مفقود',
            value: 'منتج مفقود',
            title: 'شكوي فرع',
        },
        {
            name: 'سلوك موظف فرع',
            value: 'سلوك موظف فرع',
            title: 'شكوي فرع',
        },
        {
            name: 'معلومات خاطئة',
            value: 'معلومات خاطئة',
            title: 'شكوي فرع',
        },
        {
            name: 'منتج خاطئ',
            value: 'منتج خاطئ',
            title: 'شكوي فرع',
        },
        {
            name: 'أوردر خاطئ',
            value: 'أوردر خاطئ',
            title: 'شكوي فرع',
        },
        {
            name: 'حالة تسمم',
            value: 'حالة تسمم',
            title: 'شكوي فرع',
        },
        {
            name: 'جودة منتج',
            value: 'جودة منتج',
            title: 'شكوي فرع',
        },
    ];

    compliansStatus = [
        {
            name: 'Open',
            value: 'Open',
        },
        {
            name: 'In Progress',
            value: 'In Progress',
        },
        {
            name: 'Pending',
            value: 'Pending',
        },
        {
            name: 'Canceled',
            value: 'Canceled',
        },
        {
            name: 'Completed',
            value: 'Completed',
        },
    ];

    previousUrl: string = undefined;

    currentUrl: string = undefined;

    setState() {
        this.LocalStorage.setItem('sidebarOpen', this.sidebarOpen).subscribe((data) => {});
        this.LocalStorage.setItem('sidebarItems', this.sidebarItems).subscribe((data) => {});
    }

    getPreviousUrl() {
        return this.previousUrl;
    }

    mp3SielnceNotification() {
        let sound = new Howl({
            src: ['/assets/mp3/250-milliseconds-of-silence.mp3'],
        });
        sound.play();
    }
}
